export default __webpack_public_path__ + "locales/sl/Ldap.json?hash=de2cd24d1d0bba77678b35224edebf7d";